<div class="flutterwave">
  <button class="btn-flutterwave" (click)="payViaPromise()">
    <span>Pay via</span> <br>
    Flutterwave
  </button>
</div>
